import React from 'react';
import { ApButtonMain, ApIcon, colors } from '@alixpartners/ui-components';
import Dropzone from 'react-dropzone';
import { ErrorList } from '../ErrorList';
import { bytesToSize } from 'Settings/utils';
import {
	DropZoneArea,
	DropZoneText,
	DropWrapper,
	IconWrapper,
	DescriptionText,
	ButtonWrapper,
	StatusText,
	Text,
	TextTruncate,
	ErrorWrapper,
	TextWrapper,
} from './ImportData.styles';
import {
	downloadDeckUploadData,
	importDownloadDeckData,
	uploadFile,
} from 'utils/apiRequests';

export class ImportData extends React.Component {
	state = {
		isUploading: false,
		isDone: false,
		errors: [],
		fileSize: null,
		fileName: '',
	};

	handleUpload = async file => {
		const { successClose, onUploadSuccess } = this.props;

		this.setState({
			isUploading: true,
			isDone: false,
			errors: [],
			fileSize: bytesToSize(file.size),
			fileName: file.name,
		});

		try {
			const res = await importDownloadDeckData();
			const uploadUrl = res?.data;
			const fileName = uploadUrl?.split('/rapid_strike/')[1]?.split('?')[0];

			await uploadFile(uploadUrl, file);

			const dataRes = await downloadDeckUploadData({ fileName });

			if (dataRes?.errors?.length > 0) {
				this.setState({ errors: dataRes.errors, isUploading: false });
			} else {
				this.setState({ isUploading: false, isDone: true }, successClose);
				onUploadSuccess();
			}
		} catch (err) {
			this.setState({
				errors: err?.errors || ['Unknown error occurred'],
				isUploading: false,
				isDone: false,
			});
		}
	};

	onFileSelected = acceptedFiles => {
		if (acceptedFiles.length === 0) return;
		const file = acceptedFiles[0];
		this.handleUpload(file);
	};

	renderDropContent = ({ getRootProps, getInputProps }) => {
		const { isUploading, isDone, fileName, fileSize } = this.state;
		const fileType = '.csv';

		return (
			<DropWrapper {...getRootProps()}>
				<input {...getInputProps()} accept=".csv" />

				<DropZoneArea>
					<IconWrapper>
						{isUploading ? (
							<StatusText>File upload is processing...</StatusText>
						) : (
							<ApIcon
								iconName={isDone ? 'cloud_done' : 'cloud_upload'}
								iconSize={64}
								iconColor={colors.grey3}
							/>
						)}
					</IconWrapper>

					<DropZoneText>
						{isUploading ? (
							<TextWrapper>
								<TextTruncate bold>{fileName}</TextTruncate>
								<Text>&nbsp;({fileSize})</Text>
							</TextWrapper>
						) : isDone ? (
							<Text>File was uploaded successfully</Text>
						) : (
							<DescriptionText>
								Drag <span>{fileType}</span> file here, or browse to upload
							</DescriptionText>
						)}

						<ButtonWrapper>
							<ApButtonMain iconName="baseline_add" disabled={isUploading}>
								Add file
							</ApButtonMain>
						</ButtonWrapper>
					</DropZoneText>
				</DropZoneArea>
			</DropWrapper>
		);
	};

	renderErrorState = () => {
		const { fileName, fileSize, errors } = this.state;

		return (
			<ErrorWrapper>
				<IconWrapper>
					<StatusText>The import of the file has failed</StatusText>
				</IconWrapper>

				<DropZoneText>
					<TextWrapper>
						<TextTruncate bold>{fileName}</TextTruncate>
						<Text>&nbsp;({fileSize})</Text>
					</TextWrapper>
				</DropZoneText>

				<ErrorList errors={errors} />

				<ButtonWrapper>
					<Dropzone onDrop={this.onFileSelected} noKeyboard>
						{({ getRootProps, getInputProps }) => (
							<div {...getRootProps()}>
								<input {...getInputProps()} accept=".csv" />
								<ApButtonMain iconName="baseline_add">Add file</ApButtonMain>
							</div>
						)}
					</Dropzone>
				</ButtonWrapper>
			</ErrorWrapper>
		);
	};

	render() {
		const { errors } = this.state;

		return errors.length > 0 ? (
			this.renderErrorState()
		) : (
			<Dropzone onDrop={this.onFileSelected} noKeyboard>
				{this.renderDropContent}
			</Dropzone>
		);
	}
}
